import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CodeMirror from '@uiw/react-codemirror'
import { javascript } from '@codemirror/lang-javascript';


export type SqlProps = {
    sqlCode: any
    setSqlCode: any
    setColumnGovernance: any
};

const SqlGenerator = (props: SqlProps) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    }

    function isInvalidMaxLength(item: any) {
        if (["char", "nvarchar", "nchar",
                "varchar", "string", "character",
                "character varying", "varchar2", "nvarchar2"].includes(item.srcDataType.toLowerCase())) {
            return !item.srcMaxLength || item.srcMaxLength === "0";
        }
        return false;
    }

    function validate(newRows: any) {
        let invalid = newRows.filter((item: any) => isInvalidMaxLength(item)).map(
            (item: any) => {
                return {error: `"Invalid Max Length for column ${item.srcColumnName} : '${item.srcMaxLength}'`}
            }
        );
        if (invalid.length > 0) {
            let message = "Data type errors: \n ";
            for (let i = 0; i < invalid.length; i++) {
                message += invalid[i].error + "\n ";
            }
            alert(message);
        }
    }

    const validateAndClose = () => {
        try {
            // generate fields from sql create table code
            const regex = props.sqlCode.match(/.*CREATE\s+TABLE\s+(\S+)\s*\(([\s\S]*)\)/i);
            const columns = regex ? regex[2].split(',') : [];
            const newRows = columns.map((item: any, index: number) => {
                item = item.trim().split(/[\s()]/).filter((x: any) => x !== '')
                return {
                    srcColumnName: item[0], srcDataType: item[1],
                    srcMaxLength: item.length > 2 ? item[2] : "",
                    synColumnName: item[0], synDataType: item[1],
                    synMaxLength: item.length > 2 ? item[2] : "",
                    treatmentLevel: 'low', securityClassification: 'General Business',
                    privacyClassification: 'None', id: index, srcOrdinal: index
                }
            });

            validate(newRows);
            props.setColumnGovernance(newRows);
            setOpen(false);
        }
        catch (e) {
            alert('Please check the format')
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1200,
        background: 'white',
        height: 500,
        p: 4,
    };

    const buttonStyle = {
        background: 'white',
        width: 1200,
        ml: -4,
        p: 2,
    };

    return (
        <>
            <Button id="74b2515e-1b9e-4cb9-acf6-e4e92e81b745"
                color="primary"
                variant="contained"
                onClick={handleOpen}
                sx={{ m: 1 }}
            >
                Import fields from CREATE TABLE
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
                        <h2>Create Table Schema</h2>
                        <CodeMirror
                            value={props.sqlCode}
                            height="300px"
                            extensions={[javascript({ jsx: true })]}
                            onChange={(value, viewUpdate) => {
                                props.setSqlCode(value);
                            }}
                        />
                        <Box sx={buttonStyle} display="flex" justifyContent="flex-end">
                            <Button id="3a40926c-351c-44c6-b647-949d72427cdc" color="primary" variant="contained" onClick={validateAndClose}>Generate Schema</Button>
                        </Box>
                    </Typography>
                </Box>
            </Modal>
        </>

    )

};

export default SqlGenerator;